module.exports = __webpack_public_path__ + "img/full1-min.90314e93.png";